import * as React from 'react';

type IconProps = React.SVGProps<SVGSVGElement> & { d?: string; size?: number; strokeWidth?: number };

export const Icon = ({ d, size = 20, strokeWidth = 1.7, ...p }: IconProps) => (
  <svg
    width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" {...p}
  >
    <path d={d} />
  </svg>
);

export const ArrowIcon = (p: IconProps) => <Icon {...p} d="M5 12h14M13 6l6 6-6 6" />;
export const ChartIcon = (p: IconProps) => <Icon {...p} d="M4 20V10M10 20V4M16 20v-7M22 20H2" />;
export const BoltIcon = (p: IconProps) => <Icon {...p} d="M13 2L4 14h6l-1 8 9-12h-6z" />;
export const LayersIcon = (p: IconProps) => <Icon {...p} d="M12 3l9 5-9 5-9-5 9-5zM3 13l9 5 9-5" />;
export const ChevronDownIcon = (p: IconProps) => <Icon {...p} d="M6 9l6 6 6-6" />;

/* globe: circle + equator + the meridian curve that reads as a sphere at 16px */
export const GlobeIcon = ({ size = 20, strokeWidth = 1.7, ...p }: IconProps) => (
  <svg
    width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...p}
  >
    <circle cx="12" cy="12" r="9" />
    <path d="M3 12h18M12 3c2.5 2.5 2.5 15 0 18-2.5-3-2.5-15.5 0-18z" />
  </svg>
);

/* filled play triangle (nav "watch demo" glyph) — fill, not stroke, so it reads at small size */
export const PlayIcon = ({ size = 14, ...p }: React.SVGProps<SVGSVGElement> & { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...p}>
    <path d="M8 5v14l11-7z" />
  </svg>
);
